<section
  [formGroup]="itemDetailsForm"
  class="bv-vault-item-details bv-vault-item-details--primary tw-mb-0"
>
  <div class="bv-vault-item-form-row">
    <bit-form-field disableMargin>
      <bit-label>{{ "itemName" | i18n }}</bit-label>
      <input bitInput formControlName="name" />
    </bit-form-field>
    @if (!config.hideIndividualVaultFields) {
      <bit-form-field disableMargin>
        <bit-label>{{ "folder" | i18n }}</bit-label>
        <bit-select formControlName="folderId">
          @for (folder of config.folders; track folder.id) {
            <bit-option [value]="folder.id" [label]="folder.name"></bit-option>
          }
        </bit-select>
      </bit-form-field>
    }
  </div>
</section>

@if (showBracketsOwnershipSection || showCollectionsControl) {
  <section
    [formGroup]="itemDetailsForm"
    class="bv-vault-item-details bv-vault-item-details--meta tw-mb-0"
  >
    @if (showBracketsOwnershipSection) {
      <div class="bv-vault-item-section">
        <h3 class="bv-vault-item-section__title">{{ "ownership" | i18n }}</h3>
        <bit-form-field disableMargin>
          <bit-label>{{ "whoOwnsThisItem" | i18n }}</bit-label>
          <bit-select formControlName="organizationId">
            @if (showPersonalOwnershipOption) {
              <bit-option [value]="null" [label]="userEmail$ | async"></bit-option>
            }
            @for (org of organizations; track org.id) {
              <bit-option [value]="org.id" [label]="org.name"></bit-option>
            }
          </bit-select>
        </bit-form-field>
      </div>
    }
    @if (showCollectionsControl) {
      <div class="bv-vault-item-section bv-vault-item-section--collections">
        <bit-form-field class="tw-w-full bv-vault-item-collections-field" disableMargin>
          <bit-label>{{ "collections" | i18n }}</bit-label>
          <bit-multi-select
            class="tw-w-full"
            formControlName="collectionIds"
            [baseItems]="collectionOptions"
          ></bit-multi-select>
          @if (readOnlyCollectionsNames.length > 0) {
            <bit-hint data-testid="view-only-hint">
              {{ "cannotRemoveViewOnlyCollections" | i18n: readOnlyCollectionsNames.join(", ") }}
            </bit-hint>
          }
        </bit-form-field>
      </div>
    }
  </section>
}
